import * as Icons from "@phosphor-icons/react";
import { getGlobalStats, getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Counter from "../Counter";
import DataStatuses from "const/DataStatuses";
import React from "react";
import UiRoutes from "const/UiRoutes";

const DocumentsAwaitingReviewCounter = () => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const globalStats = useSelector(getGlobalStats);

  const businessId = useSelector(getSelectedBusinessId);

  const {
    documents: {
      [DataStatuses.EXPORTED]: { count = 0, paid = 0 } = {}
    } = {}
  } = globalStats;

  return (
    <Counter
      to={`/${businessId}${UiRoutes.DOCUMENTS}?status=unpaid`}
      theme="warning"
      mainText={(count - paid) || 0}
      secondaryText={uiTexts.documents.toLowerCase()}
      description={messages.dashboardDocsShouldPay}
      icon={Icons.FileText}
      loading={!globalStats.documents} />
  );
};

export default React.memo(DocumentsAwaitingReviewCounter);
